/**
 * Typed API client backed by the auto-generated OpenAPI schema.
 *
 * This file is .js (not .ts) so CRA's webpack picks it up without
 * extra TS config. The accompanying `schema.d.ts` is auto-generated
 * by `yarn api:gen` and is consumed by editors/IDEs for autocomplete
 * even from .jsx callers.
 */
import createClient from "openapi-fetch";

const baseUrl = process.env.REACT_APP_BACKEND_URL;

if (!baseUrl) {
  throw new Error("REACT_APP_BACKEND_URL is not set");
}

export const apiClient = createClient({ baseUrl });

// Add the auth header on every request (mirrors the legacy axios interceptor).
apiClient.use({
  onRequest({ request }) {
    const token = localStorage.getItem("familyos_token");
    if (token) request.headers.set("Authorization", `Bearer ${token}`);
    return request;
  },
});
